import { Skeleton as SkeletonUi, Typography, styled } from "@l2r-front/l2r-ui"

export const Container = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
}))

export const Skeleton = styled(SkeletonUi)(({ theme }) => ({
    width: "100%",
    height: 130,
    borderRadius: 12,
    transform: "none",
    marginTop: theme.spacing(2),
}))

export const EmptyText = styled(Typography)(({ theme }) => ({
    color: theme.palette["text/secondary"].main,
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
}))

export const ErrorText = styled(Typography)(({ theme }) => ({
    color: theme.palette["error"].main,
}))